var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z",
    fill: "#C92E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83746 5.87497L6.73132 5.98106L6.83746 6.08715L8.1031 7.35221C8.30033 7.55704 8.29753 7.87313 8.10406 8.06651C8.00265 8.16787 7.8755 8.21468 7.74714 8.21468C7.61879 8.21468 7.49163 8.16787 7.39022 8.06651L6.12361 6.80048L6.01757 6.69448L5.91153 6.80048L4.60998 8.10143C4.50857 8.2028 4.38141 8.24961 4.25305 8.24961C4.1247 8.24961 3.99754 8.2028 3.89613 8.10143C3.70142 7.90681 3.70142 7.58272 3.89613 7.3881L5.19768 6.08715L5.30382 5.98106L5.19768 5.87497L3.93107 4.60894C3.73636 4.41431 3.73636 4.09023 3.93107 3.8956C4.12582 3.70094 4.45017 3.70094 4.64492 3.8956L5.91153 5.16163L6.01757 5.26763L6.12361 5.16163L7.34654 3.93926C7.54129 3.7446 7.86564 3.7446 8.06039 3.93926C8.2551 4.13388 8.2551 4.45797 8.06039 4.65259L6.83746 5.87497Z",
    fill: "#C92E2E",
    stroke: "#F99995",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.f87431192189514af05e39307ef43ac9.svg";
export { ForwardRef as ReactComponent };